import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-lanzamiento',
  subtitle: 'Consulta los datos del checklist de Go Live y establece la fecha de revisión post-lanzamiento.',
  go_live_checklist: {
    labels: {
      yes: 'Sí',
      no: 'No',
    },
    title: 'Checklist de Go Live',
    form: {
      is_google_business_available: {
        label: 'Google Business disponible',
      },
      is_smart_pricing_configured: {
        label: 'Precios más bajos que Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Flyer promocional enviado',
      },
      is_menu_fully_configured: {
        label: 'Todos los artículos del menú disponibles',
      },
      has_offers_on_competitor_platforms: {
        label:
          '¿El restaurante tiene ofertas activas en Wolt, Uber, Lieferando (excepto la oferta de entrega gratuita)?',
      },
      is_instagram_story_shared: {
        label: 'Historia de Instagram compartida con el propietario',
      },
      is_order_system_connected_to_website: {
        label:
          'Sitio web de Foodamigos conectado O botón de pedido online añadido en el sitio web propio del restaurante',
      },
      google_business_connected_by: {
        label: '¿Cómo obtuvimos acceso al perfil de Google Business?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
            'El responsable de ventas invitó a google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'El responsable de ventas envió la primera solicitud desde el teléfono del propietario',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'El responsable de onboarding solicitó el perfil de Google Business (el SM no invitó ni solicitó acceso)',
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Guardar',
    },
    toasts: {
      success: 'Guardado correctamente',
      error: 'Error al guardar',
    },
  },
  post_launch_screening: {
    title: 'Revisión post-lanzamiento',
    form: {
      screening_date: {
        label: 'Fecha de revisión',
      },
    },
    toasts: {
      success: 'Guardado correctamente',
      error: 'Error al guardar',
    },
    buttons: {
      save: 'Guardar',
    },
  },
};
